var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvancement = function SvgAdvancement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.146 18.33a1.34 1.34 0 0 1-1.186-.67l-1.898-3.286-4.353 7.539c3.279 0 6.569-.042 9.841-.042h10.777L15.193 8.364l-4.887 9.252a1.34 1.34 0 0 1-1.16.715zm-.026-1.34 5.332-10.093a.838.838 0 0 1 1.481 0l7.969 15.086a.837.837 0 0 1-.74 1.228c-3.957 0-7.928.042-11.877.042H.84a.838.838 0 0 1-.726-1.256l5.224-9.047a.836.836 0 0 1 1.45 0l2.333 4.04z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.436 4.656a.34.34 0 0 1 .339-.335h.74a.33.33 0 0 1 .33.335l-.033 2.68a.34.34 0 0 1-.34.336h-.739a.33.33 0 0 1-.33-.335l.033-2.68z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.177 5.176c.33.13.686-.114.686-.468V1.25a.502.502 0 0 0-.686-.468L10.772 2.51a.503.503 0 0 0 0 .936l4.405 1.729zm-1.93-2.197 1.276.5v-1z",
    clipRule: "evenodd"
  })));
};
export default SvgAdvancement;